<script setup lang="ts">
import VocabList from './VocabList.vue';
import VocabDetails from './VocabDetails.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import { useSessionStore } from '../../../stores';
import Iframe from '../../General/Iframe.vue';
import { Session } from '../../../types/session';

const sessionStore = useSessionStore()

</script>

<template>
    <Fullscreen v-if="sessionStore.classContent?.[Session.vocab].scormUrl"
        class="p-3 h-full w-full flex flex-col items-center justify-evenly overflow-auto">
        <Iframe :src="sessionStore.classContent[Session.vocab].scormUrl" orientation="full"></Iframe>
    </Fullscreen>

    <Fullscreen v-else class="flex flex-1 h-full">
        <div
            class="basis-1/3 p-3 lg:p-8 flex flex-col gap-3 overflow-auto border-r-2 border-neutral-200 border-dashed hide-scrollbar">
            <VocabList />
        </div>
        <div class="basis-2/3 p-3 lg:p-8">
            <VocabDetails :key="sessionStore.currentVocabId" />
        </div>
    </Fullscreen>
</template>